<script setup>
import {trackerTypes} from "@/constants/trackers";
import defaults from "@/constants/defaults";
import Folder from "@/components/trackers/trackerEdit/Folder.vue";
import Editor from "@/components/Editor.vue";
import {inject, onMounted, ref, watch} from "vue";
import VueMultiselect from "vue-multiselect";
import trackersService from "@/services/trackers.service";
import {useStore} from "vue2-helpers/vuex";

defineProps(['initFolderId','selectedTemplate','hasTemplates','selectTemplateStep']);
const emit = defineEmits(['update:selectTemplateStep']);
const store = useStore();

const trackerId = inject('trackerId');
const tracker = inject('tracker');
const canEditInfo = inject('canEditInfo');
const showLink = ref(false);
const linkedTracker = ref(null);
const pocTrackersList = ref([]);

watch(linkedTracker, (value) => {
    if (value) {
        showLink.value = true;
        tracker.linkedTrackerId = value.id;
    } else {
        tracker.linkedTrackerId = null;
    }
});

watch(showLink, (value) => {
    if (!value) {
        linkedTracker.value = null
    }
});

watch([() => tracker.linkedTrackerId, pocTrackersList], () => {
    if (tracker.linkedTrackerId && pocTrackersList.value.length) {
        const foundTracker = pocTrackersList.value.find(item => item.id === tracker.linkedTrackerId);

        if (foundTracker) {
            showLink.value = true;
            linkedTracker.value = foundTracker;
        } else {
            linkedTracker.value = null;
        }
    }
});

onMounted(() => {
    getPocTrackersList();
})

function changeTemplate() {
    if (tracker.type !== trackerTypes.REQUEST) {
        emit('update:selectTemplateStep', true);
    }
}

async function getPocTrackersList() {
    const {data} = await trackersService.getList('POC');
    pocTrackersList.value = data.filter(tracker => tracker.id !== trackerId.value);
}
</script>

<template>
    <div>
        <ul :class="{'list-template list-template--w-change': !!selectedTemplate, 'list-template-new': !selectedTemplate}">
            <li class="list-template__list">
                <a
                    v-if="selectedTemplate || (tracker.type === trackerTypes.PRIVATE && canEditInfo && hasTemplates)"
                    class="link link-normal"
                    @click="changeTemplate"
                    style="text-decoration: none"
                >
                    <template v-if="selectedTemplate">
                        <div>
                            <h5 class="heading5 heading5--secondary">{{selectedTemplate.name}}</h5>
                        </div>

                        <span v-if="tracker.type !== trackerTypes.REQUEST" class="link link-normal">
                            Change
                        </span>
                    </template>

                    <template v-else>
                        Change tracker template
                    </template>
                </a>
            </li>
        </ul>

        <b-row v-if="tracker.type === trackerTypes.POC && store.getters.isCoPaceEnterprise" class="mb-4 mt-4">
            <b-col cols="12" sm="4" class="mt-2 mb-sm-0">
                <div class="input-checkbox">
                    <input id="show-link" type="checkbox" v-model="showLink">
                    <label for="show-link">Link Tracker</label>
                </div>
            </b-col>

            <b-col cols="12" sm="8">
                <VueMultiselect
                    v-if="showLink"
                    v-model="linkedTracker"
                    :options="pocTrackersList"
                    select-label=""
                    deselect-label=""
                    placeholder="Select Tracker"
                    label="name"
                    track-by="name"
                    class="multiselect-mid selectbox selectbox-mid"
                />
            </b-col>
        </b-row>

        <b-row class="mb-4 mt-4">
            <b-col cols="12" sm="7" class="mb-4 mb-sm-0">
                <div class="form form-modal">
                    <h5 class="heading5 heading5--secondary">Tracker name</h5>
                    <b-form-input class="form-control--mid" v-model="tracker.name" placeholder="" :disabled="!canEditInfo"></b-form-input>
                </div>
            </b-col>

            <b-col cols="12" sm="5">
                <Folder/>
            </b-col>
        </b-row>

        <h5 class="heading5 heading5--secondary">Description</h5>

        <div class="mb-3">
            <Editor
                v-model="tracker.description"
                :disabled="!canEditInfo"
                :apiKey="apiKeys.tinyMCE"
                :init="defaults.editorOptions"
            />
        </div>
    </div>
</template>

<style scoped>

</style>
